import { useState, useRef } from "react";
import FormDropDown from "../../../forms/DropDownList/FormDropDown";
import Toggle from "../../../forms/Toggle/Toggle";
import "./ClawResultTriggers.scss";

const ClawLoseResultTriggers = (props) => {
    const loseTriggers = props.customisationData?.triggerOptions?.inGameTriggers?.loserTrigger ?? [];
    const defaultOptionsList = [
        {label: 'Play All Selected', value: -2},
        {label: 'Choose Random From Selected', value: -1},
    ];
    /* const selectedOptionsList = [
        {label: 'Default', value: -1},
        {label: 'Skip', value: -2},
    ];
    loseTriggers.forEach((trigger, index) => {
        defaultOptionsList.push({label: trigger.name && trigger.name.length > 0 ? trigger.name : `Trigger ${index + 1}`, value: index});
        selectedOptionsList.push({label: trigger.name && trigger.name.length > 0 ? trigger.name : `Trigger ${index + 1}`, value: index});
    }); */

    console.log('Lose Triggers props: ', props);
    let receivedData = props.passedInPreviewData?.resultControl ?? props.featureVars?.resultControl ?? {};
    console.log('Lose Result Triggers Received Data', receivedData);
    const defaultTriggerValue = receivedData.defaultLoseTrigger ?? -1;
    // const selectedTriggerValue = receivedData.selectedLoseTrigger ?? -1;

    const defaultTriggerIndex = defaultOptionsList.findIndex(option => option.value === defaultTriggerValue);
    // const selectedTriggerIndex = selectedOptionsList.findIndex(option => option.value === selectedTriggerValue);

    const skipSelected = receivedData?.skipLoseTriggers === true;

    const resetToDefault = () => {
        props.changeValFunc("resultControl", "selectedLoseTriggers", loseTriggers.map(trigger => trigger.playAsDefault === true));
        props.changeValFunc("resultControl", "skipLoseTriggers", false);
    }

    return (
        <>
            <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    <div className={`fl-row`}>
                        <div className="form-field-content label no-bottom-margin">Skip Lose Triggers This Turn</div>
                        <div className="grow-100"></div>
                        <Toggle id={`loseTriggerToggle_skip`} currentState={skipSelected} toggleFunc={(e, id) => {receivedData.skipLoseTriggers = !skipSelected; props.changeValFunc("resultControl", "skipLoseTriggers", receivedData.skipLoseTriggers);}} variant='compact' />
                    </div>
                </div>
            </div>
            <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    <div className="fl-row" style={{opacity: skipSelected ? 0.25 : 1}}>
                        <FormDropDown
                            className={'wide-select'}
                            label="Lose Trigger Behaviour"
                            id="defaultLoseTrigger"
                            selectFunc={(e, id, item) => {props.changeValFunc("resultControl", "defaultLoseTrigger", item.val ?? item.value);}}
                            items={defaultOptionsList}
                            currentIndex={defaultTriggerIndex}
                            showErrors={false}
                            enabled={!skipSelected}
                        />
                    </div>
                </div>
            </div>
            <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    <div class="info-text light-text" style={{opacity: skipSelected ? 0.25 : 1}}>Toggle Lose Triggers on and off below. The highlighted options are the ones that will play by default.</div>
                </div>
            </div>
            <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    {loseTriggers.map((trigger, index) => {
                        const value = receivedData.selectedLoseTriggers ? receivedData.selectedLoseTriggers[index] : false;
                        let highLightClass = '';
                        if (trigger.playAsDefault) {
                            if (value === true) {
                                highLightClass = ' on';
                            } else {
                                highLightClass = ' off';
                            }
                        }

                        return (
                            <div key={index} className={`fl-row claw-controls-default-trigger${highLightClass}`} style={{opacity: skipSelected ? 0.25 : 1}}>
                                <div className="form-field-content label no-bottom-margin">{trigger.name}</div>
                                <div className="grow-100"></div>
                                <Toggle 
                                    id={`loseTriggerToggle_${index}`} 
                                    currentState={value} 
                                    toggleFunc={(e, id) => {receivedData.selectedLoseTriggers[index] = !value; props.changeValFunc("resultControl", "selectedLoseTriggers", receivedData.selectedLoseTriggers);}} 
                                    variant='compact' 
                                    enabled={!skipSelected}
                                />
                            </div>
                        )
                    })}
                </div>
            </div>
            <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    <button class="standard-button" style={{minWidth: '100%'}} onClick={resetToDefault}><div class="fl-row">Reset Lose Triggers To Default</div></button>
                </div>
            </div>
            {/* <div className="fc-column">
                <div className={`feature-control-holder fc-expanded`}>
                    <div className="fl-row">
                        <FormDropDown
                            className={'wide-select'}
                            label="Select Next Lose Trigger"
                            id="selectNextLoseTrigger"
                            selectFunc={(e, id, item) => {props.changeValFunc("resultControl", "selectedLoseTrigger", item.val ?? item.value);}}
                            items={selectedOptionsList}
                            currentIndex={selectedTriggerIndex}
                            showErrors={false}
                            enabled={true}
                        />
                    </div>
                </div>
            </div> */}
        </>
    )
}

export default ClawLoseResultTriggers;
